import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { getListDriverAccount } from 'src/features/driverSlice';
import Results from './Results.js';
import ToolBar from './ToolBar.js';
import {
  PAGE_SIZE_LIST,
  STATUS_API
} from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';

const DriverAccounts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const classes = useStyles();
  const query = useQuery();
  const [params, setParams] = useState({
    page: 1,
    page_size: PAGE_SIZE_LIST
  });

  const agencyId = useSelector(state => state.authSlice.agencyId);
  const userId = useSelector(state => state.authSlice.userId);

  const page = query.get('page') || 1;
  const keyword = query.get('keyword');

  const statusCreateAccount = useSelector(state => state.driverSlice.statusCreateAccount);
  const statusDeleteAccount = useSelector(state => state.driverSlice.statusDeleteAccount);
  const statusDelete = useSelector(state => state.driverSlice.statusDelete);
  const statusDeleteMulti = useSelector(state => state.driverSlice.statusDeleteMulti);
  const statusUpdate = useSelector(state => state.driverSlice.statusUpdate);
  const statusUpdatePassword = useSelector(state => state.driverSlice.statusUpdatePassword);
  const listDriverAccounts = useSelector(state => state.driverSlice.listDriverAccounts);

  useEffect(() => {
    const queryValue = {
      ...params,
      page: page ? page : undefined,
      keyword: keyword ? keyword : undefined
    };
    setParams(queryValue);
  }, [query, agencyId]);

  const getListDriverAccountsWithParams = query => {
    navigate('/app/manage/accounts-driver?' + _convertObjectToQuery(query));
    if(userId){
      dispatch(getListDriverAccount(query));
    }
  };

  useEffect(() => {
    if(userId){
      dispatch(getListDriverAccount(params));
    }
  }, [userId]);

  useEffect(() => {
    if (
      statusCreateAccount === STATUS_API.SUCCESS ||
      statusDeleteAccount === STATUS_API.SUCCESS ||
      statusDelete === STATUS_API.SUCCESS ||
      statusUpdate === STATUS_API.SUCCESS ||
      statusUpdatePassword === STATUS_API.SUCCESS ||
      statusDeleteMulti === STATUS_API.SUCCESS
    ) {
      getListDriverAccountsWithParams(params);
    }
  }, [
    statusCreateAccount,
    statusDeleteAccount,
    statusDelete,
    statusUpdate,
    statusUpdatePassword,
    statusDeleteMulti
  ]);

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <ToolBar
            searchRef={getListDriverAccountsWithParams}
          />
          <Results
            className="mt-3"
            listDriverAccounts={listDriverAccounts}
            getListDriverAccountsRef={getListDriverAccountsWithParams}
          />
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    marginTop: '17px'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

export default DriverAccounts;
